import { FormControl } from "@commonlibs";
import styled, { css } from "styled-components";

export const FileUploadControlsRoot = styled(FormControl)(
    () => css`
        justify-content: center;
    `,
) as typeof FormControl;
